import api from "../Token";

export const deleteUserFormacao = async (dados) => {
  try {
    const { data } = await api.post("/deleteUserFormacao", dados);
    return data;
  } catch (error) {
   
    if (error.response) {
      return {
        success: false,
        status: error.response.status,
        ...error.response.data, 
      };
    }

  
    if (error.request) {
      return {
        success: false,
        status: 0,
        message: "Não foi possível comunicar com o servidor.",
      };
    }

  
    return {
      success: false,
      status: 0,
      message: error.message || "Erro inesperado.",
    };
  }
};